import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';


        
const grantableCertificate = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.ArialBlack]}>Certificate</Text>

                <View style={style.solidLine} />
               
                <Text style={[style.paragraph, { marginTop: 20, fontSize: 12, lineHeight: 2 }]}>
               Certified that the {result.institutionName} is Recognized and 100% aided by the School Education and Sports Department during the period when {result.employeeName} rendered her services in this Jr. College.
                </Text>
                      
           
                <Text style={[style.signature, {marginTop: 20}]}>Head of Office</Text>
           </View>

);

export default grantableCertificate;